import { NavigationHighlightLinkGroup } from '@tmh-website/shared/cms';

/**
 * Determines whether the passed-in group has any children.
 *
 * @param group - The `NavigationHighlightLinkGroup` to check.
 *
 * @returns - `true` if the `group` has any children, otherwise `false`.
 */
export const hasGroupChildren = (group: NavigationHighlightLinkGroup): boolean => {
  return Array.isArray(group.children) && group.children.length > 0;
};
